import { base64UrlEncode, Calculator } from 'vtils'

export interface MallConfig {
  /**
   * 所属环境。可选值：
   *
   * - `test`: 测试环境
   * - `prod`: 生产环境
   *
   * @default 'prod'
   */
  env?: 'test' | 'prod'

  /**
   * 运营渠道 ID。
   */
  operationChannelId?: string

  /**
   * 业务首页地址。
   */
  homeUrl?: string

  /**
   * 业务我的订单地址。
   */
  orderUrl?: string

  /**
   * 是否纯净版，设为 true 会隐藏 TAB 栏，购物车下的去看看、猜你喜欢等和多多商城强相关的元素。
   */
  pure?: boolean
}

export class mall {
  private static mallConfig: MallConfig

  static config(config: MallConfig) {
    this.mallConfig = config
  }

  static getUrl(pageName: string, params?: Record<string, any>) {
    const isTv = pageName.indexOf('Tv') === 0
    return `${
      this.mallConfig.env === 'test'
        ? isTv
          ? 'https://tv-h5.duotest.cn/app/duoduo-mall/'
          : 'https://h5.gogpay.cn/h5-test/app/duoduo-mall/'
        : isTv
        ? 'https://tv-h5.gogpay.cn/duoduo-mall/index.html'
        : 'https://h5.gogpay.cn/h5/app/duoduo-mall/'
    }#/bridge/index?isFull=true&isLogin=true&isAuth=true${
      this.mallConfig.pure ? `&isPure=true` : ''
    }${
      this.mallConfig.operationChannelId
        ? `&refUserGroupId=${this.mallConfig.operationChannelId}`
        : ''
    }${
      this.mallConfig.homeUrl
        ? `&bizHomeUrl=${encodeURIComponent(this.mallConfig.homeUrl)}`
        : ''
    }${
      this.mallConfig.orderUrl
        ? `&bizOrderUrl=${encodeURIComponent(this.mallConfig.orderUrl)}`
        : ''
    }&__q__=${base64UrlEncode(
      JSON.stringify({
        name: pageName,
        params: params,
      }),
    )}`
  }

  static navigateTo(pageName: string, params?: Record<string, any>) {
    // @ts-ignore
    if (window.dcb) {
      // @ts-ignore
      window.dcb.navigateTo({
        url: this.getUrl(pageName, params),
      })
    } else {
      location.href = this.getUrl(pageName, params)
    }
  }

  static calculator = Calculator.make({
    decimalPlaces: 2,
    rounding: Calculator.decimal.ROUND_HALF_EVEN,
  })
}
